export const DEFAULT_SEEK_STEP_SEC = 10

export const SEEK_ANIMATION = {
  TAP: 'tap',
  CLICK: 'click',
}

export const RewindTypes = {
  dvr: 'dvr',
  timeshift: 'timeshift',
  rewind: 'rewind',
} as const
export type RewindTypes = (typeof RewindTypes)[keyof typeof RewindTypes]
